import { render } from "./KnowledgePointsView.vue?vue&type=template&id=24456a32"
import script from "./KnowledgePointsView.vue?vue&type=script&lang=js"
export * from "./KnowledgePointsView.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__